export default function adminMessage() {
  const indefiniteDisplay = document.getElementById('admin_message_indefinite_display');
  const startDate = document.getElementById('admin_message_start_date');
  const endDate = document.getElementById('admin_message_end_date');

  indefiniteDisplay.addEventListener('change', (e) => {
    startDate.value = null;
    endDate.value = null;

    const isIndefinite = e.target.value === 'true';
    startDate.disabled = isIndefinite;
    endDate.disabled = isIndefinite;
  });
};